import { useCallback, useEffect } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../config/firebase";

/**
 * Fetches pending assignments for childUser personnel from Firestore.
 */
export const useSignaturePendingAssignments = ({
  currentUser,
  personnel,
  setPendingAssignments,
}) => {
  const fetchPendingAssignments = useCallback(async () => {
    try {
      if (!currentUser.email || currentUser.permissions !== "childUser") return;

      const currentPersonnel = personnel.find(
        (p) => p.email === currentUser.email,
      );
      if (!currentPersonnel) return;

      const assignmentsRef = collection(db, "assignments");
      const q = query(
        assignmentsRef,
        where("personnelId", "==", currentPersonnel.personalNumber),
        where("status", "==", "pending"),
      );

      const querySnapshot = await getDocs(q);
      const assignments = [];
      querySnapshot.forEach((docSnap) => {
        assignments.push({ id: docSnap.id, ...docSnap.data() });
      });

      setPendingAssignments(assignments);
    } catch (error) {
      console.error("Error fetching pending assignments:", error);
    }
  }, [personnel, currentUser, setPendingAssignments]);

  useEffect(() => {
    if (currentUser.email && currentUser.permissions === "childUser") {
      fetchPendingAssignments();
    }
  }, [fetchPendingAssignments, currentUser]);

  return { fetchPendingAssignments };
};
